import React from 'react';
import { useIntl } from 'react-intl';
import Security from '../../commons/security/Security.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import { StyledTooltip } from '../../commons/utils/TableStyles';

export const esOrigenSolicitud = (origen, solicitudId) =>
	origen === 'Solicitud' && Boolean(solicitudId) && ConfigBusiness.get('mantenimientos.solicitudes.habilitado') === 'true';

export const puedeVerSolicitudOrigen = () => Security.hasPermission('SOLICITUDES_LISTAR');

const OrigenSolicitud = ({ solicitudId, ticketId }) => {
	const intl = useIntl();

	return (
		<StyledTooltip
			title={intl.formatMessage({ id: 'ticketsGrid.origen_solicitud.tooltip', defaultMessage: 'Solicitud: {numero}' }, { numero: 'S-' + solicitudId })}
			arrow
			placement="top"
		>
			<div style={{ textAlign: 'center', display: 'flex', alignItems: 'center' }}>
				<i className="la la-file-text-o" style={{ color: '#506078', fontSize: '28px', width: '24px', marginRight: '10px' }} />
				<span>{ticketId}</span>
			</div>
		</StyledTooltip>
	);
};

export default OrigenSolicitud;
